import { type ReactNode } from 'react';
import { useEffect } from 'react';
import { Marker, useMap } from 'react-leaflet';
import { type LatLng, type LatLngExpression } from 'leaflet';

interface SelectedLocationControllerProps {
    onSelect?: (selected: LatLng) => void;
    selected?: LatLngExpression;
    disabled?: boolean;
}

export function SelectedLocationController({
    onSelect,
    disabled,
    selected,
}: SelectedLocationControllerProps): ReactNode {
    const map = useMap();

    useEffect(() => {
        if (!selected) {
            return;
        }
        map.panTo(selected);
    }, [map, selected]);

    useEffect(() => {
        if (disabled) {
            return;
        }
        map.on('click', (event) => {
            if (
                !(event.originalEvent.target as HTMLElement).className.includes(
                    'leaflet-container',
                )
            ) {
                return;
            }
            onSelect?.(event.latlng);
        });
        return () => {
            map.off('click');
        };
    }, [disabled, map, onSelect]);

    return <>{selected ? <Marker position={selected} /> : null}</>;
}
